import { render } from "./mainMenu.vue?vue&type=template&id=de90a446&scoped=true"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"

import "./mainMenu.vue?vue&type=style&index=0&id=de90a446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de90a446"]])

export default __exports__